export const E_TypesReports = {
  simple: 'reportVendaOrcamento',
  cupom58mm: 'reportCoupon58mm',
  contrato: 'reportContrato',
}
